import { TabbedForm as RATabbedForm, SaveButton, Toolbar } from "react-admin";

const MyToolbar = () => (
  <Toolbar>
    <SaveButton type="button" />
  </Toolbar>
);

export const TabbedForm = ({ children }) => (
  <RATabbedForm toolbar={<MyToolbar />} sanitizeEmptyValues>
    {children}
  </RATabbedForm>
);

TabbedForm.Tab = RATabbedForm.Tab;
